<template></template>
<script>
  export default {
    name: 'Logout',
    created () {
      delete localStorage.token
      this.$store.dispatch('logout')
      this.$router.push('/')
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Login/Logout.vue